import { Injectable, Injector } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ConfirmationOverlayComponent } from '../components/confirmation-overlay/confirmation-overlay.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationOverlayService {
  private overlayRef: OverlayRef | null = null;

  constructor(
    private overlay: Overlay,
    private injector: Injector
  ) {}

  showConfirmation(title: string, message: string, disableYesButton: boolean = false, showOnlyOkButton: boolean = false): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (this.overlayRef) {
        this.overlayRef.dispose();
      }

      const positionStrategy = this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically();

      this.overlayRef = this.overlay.create({
        positionStrategy,
        hasBackdrop: true,
        backdropClass: 'cdk-overlay-dark-backdrop',
        panelClass: 'confirmation-overlay-panel'
      });

      const portal = new ComponentPortal(ConfirmationOverlayComponent, null, this.injector);
      const componentRef = this.overlayRef.attach(portal);
      const component = componentRef.instance;

      component.title = title;
      component.message = message;
      component.disableYesButton = disableYesButton;
      component.showOnlyOkButton = showOnlyOkButton;

      component.confirm.subscribe(() => {
        this.overlayRef?.dispose();
        this.overlayRef = null;
        resolve(true);
      });

      component.cancel.subscribe(() => {
        this.overlayRef?.dispose();
        this.overlayRef = null;
        resolve(false);
      });

      this.overlayRef.backdropClick().subscribe(() => {
        this.overlayRef?.dispose();
        this.overlayRef = null;
        resolve(false);
      });
    });
  }
}
